import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  fullWidth?: boolean;
  scrollTo?: string;
  href?: string;
}
export function Button({
  children,
  className = '',
  variant = 'primary',
  fullWidth = false,
  scrollTo,
  href,
  onClick,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 rounded-lg font-medium transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed text-lg';
  const variants = {
    primary: 'bg-teal text-white hover:bg-teal-dark shadow-lg hover:shadow-xl focus:ring-teal',
    secondary: 'bg-navy text-white hover:bg-navy-light shadow-lg hover:shadow-xl focus:ring-navy',
    outline: 'border-2 border-teal text-teal hover:bg-teal/10 focus:ring-teal'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (href) {
      window.open(href, '_blank', 'noopener,noreferrer');
    }
    if (scrollTo) {
      document.getElementById(scrollTo)?.scrollIntoView({
        behavior: 'smooth'
      });
    }
    onClick?.(e);
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${widthClass} ${className}`} onClick={handleClick} {...props} data-id="element-207">
      {children}
    </motion.button>;
}